import { useState } from "react";
import { AP_Master } from "../../Configuration/API_URL";
import { ApiResDecrypt } from "../../CommonMethhods/CommonMethods";
import axios from "axios";

const deactivateAp = async (payload) => {
  const token = localStorage.getItem("ssoToken");
  const response = await axios.post(AP_Master.DEACTIVATE_AP, payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      reserv: 1,
    },
  });
  return response.data;
};

export const useDeactivate = () => {
  const [isLoading, setIsLoading] = useState(false);

  const deactivateAP = async (payload) => {
    setIsLoading(true);

    try {
      const response = await deactivateAp(payload);
      const decryptedResponse = ApiResDecrypt(response);
      if (decryptedResponse.status === 0) {
        return { success: true, data: decryptedResponse };
      }
      return { success: false, data: decryptedResponse };
    } catch (err) {
      console.error(err);
      return { success: false };
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, deactivateAP };
};
